import React from "react";
import { TBFL1BackendRecord } from "../../../../redux/app/bfl-1/@types";
import { marpolUtils } from "../../../../redux/app/marpol";
import { BFL1TableColumns } from "./BFL1TableRows";
import MARPOLModule from "../../../../redux/app/marpol/operation.types";

function getSignTableRows(record: TBFL1BackendRecord): BFL1TableColumns[] {
	function getFormattedDate(dateWithTime: string) {
		return dateWithTime;
	}

	function getVerificationUser() {
		if (!record.verifiedBy) return undefined;
		return {
			...record.verifiedBy,
			date: record.submittedBy.date,
		};
	}

	function renderSignatures() {
		if (!record.submittedBy) return null;

		return (
			<h4 className="font-medium leading-9 uppercase">
				RECORDED BY: {renderSubmittedBy()}
				<br />
				{record.editedBy && (
					<>
						UPDATED BY: {renderSignatureItem(record.editedBy)}
						<br />
					</>
				)}
				VERIFIED BY: {renderVerifiedBy()}
				<br />
				APPROVED BY: {renderApprovedBy()}
			</h4>
		);
	}

	function renderStrikeOffSign() {
		if (!record.strikedBy) return null;
		return (
			<h4 className="font-medium leading-9 uppercase">
				STRUCK OFF BY: {renderSignatureItem(record.strikedBy)}
				<div className="w-full">
					STRUCK OFF REASON:
					<span className="ml-1 font-bold text-red-700">
						{record.strikeOffReason}
					</span>
				</div>
			</h4>
		);
	}

	function renderSignatureItem(
		user?: MARPOLModule.RecordUser,
		isPending: boolean = false
	) {
		if (!user || isPending) return "PENDING";
		const { date, designation, name, staffId } = user;
		return `${name} [${designation}] - ${staffId}
		 on ${getFormattedDate(date)}`;
	}

	function renderSubmittedBy() {
		if (!record.submittedBy) return null;
		const signData = record.submittedBy;
		const isPending = !record.submittedBy;
		if (!signData || isPending) return "PENDING";
		const { date, designation, name, staffId } = signData;
		return `${name} [${designation}] - ${staffId}
		 on ${getFormattedDate(date)}`;
	}

	function renderVerifiedBy() {
		if (!record.verifiedBy) return null;
		const signData = record.verifiedBy;
		const isPending = !record.verifiedBy;
		if (!signData || isPending) return "PENDING";
		const { date, designation, name, staffId } = signData;
		return `${name} [${designation}] - ${staffId}`;
	}

	function renderApprovedBy() {
		if (!record.approvedBy) return null;
		const signData = record.approvedBy;
		const isPending = !record.approvedBy;
		if (!signData || isPending) return "PENDING";
		const { date, designation, name, staffId } = signData;
		return `${name} [${designation}] - ${staffId}
		 on ${getFormattedDate(date)}`;
	}

	return [
		[null, null, null, renderSignatures()],
		[null, null, null, renderStrikeOffSign()],
	];
}

export default getSignTableRows;
